/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { neuronsGetApiV3Neurons } from "../../funcs/neuronsGetApiV3Neurons.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NeuronsRequest$inboundSchema.optional(),
};

export const tool$neuronsGetApiV3Neurons: ToolDefinition<typeof args> = {
  name: "neurons-get-api-v3-neurons",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await neuronsGetApiV3Neurons(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
